import * as React from "react";
import { Button, TextField, Box } from "@mui/material";
import { Publish as PublishIcon } from "@mui/icons-material";
import "./AddAsset4.css";
import { Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import { FaCloudUploadAlt} from 'react-icons/fa';

export default function AddAsset4({ handlePrevious, handleNext, order }) {
  const onSubmitForm = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "success",
      title: "Listing Submitted.",
      text: "Our team will be in touch with you, shortly",
      showConfirmButton: true,
    });
  };

  return (
    <div className="addAsset1_Main">
      <Row>
        <Col md={12}>
          <input type="file" className="fileInput" id="fileInput" />
          <label for="fileInput" className="fileInput_alt">
          <FaCloudUploadAlt size={30}  className="fileInput_alt_icon"/> 
         <br/>
          Upload Documents
          </label>
        </Col>
        <Col md={12}>
          <button className="submitBtn" onClick={onSubmitForm}>
            Submit
          </button>
        </Col>
      </Row>
      <div className="chngBtnDiv">
        <button
          className="prevBtn"
          onClick={handlePrevious}
          disabled={order === 0}
        >
          Prev
        </button>
        <button className="nextBtn" disabled={order === 3} onClick={handleNext}>
          Next
        </button>
      </div>
      <br />
    </div>
  );
}
